interface RtkRequestStatusCodes {
  pending: "pending";
  fulfilled: "fulfilled";
  rejected: "rejected";
  idle: "idle";
}

const rtkRequestStatusCodes: RtkRequestStatusCodes = {
  pending: "pending",
  fulfilled: "fulfilled",
  rejected: "rejected",
  idle: "idle",
};

export default rtkRequestStatusCodes;
